/**
 * WorkspaceStatsSection - Statistics cards section for workspace page
 * Displays total keywords, searches, and AI analyses
 */

import React from 'react';
import SimpleStatCard from '../SimpleStatCard';

interface WorkspaceStatsSectionProps {
  totalSavedKeywords: number;
  totalSearches: number;
  totalAiAnalyses: number;
  isLoading: boolean;
  isLoadingCounts: boolean;
}

const WorkspaceStatsSection: React.FC<WorkspaceStatsSectionProps> = ({
  totalSavedKeywords,
  totalSearches,
  totalAiAnalyses,
  isLoading,
  isLoadingCounts
}) => {
  const workspaceStatsData = [
    { title: "Keywords", value: totalSavedKeywords.toString(), icon: null },
    { title: "Searches", value: totalSearches.toString(), icon: null },
    { title: "AI Analysis", value: totalAiAnalyses.toString(), icon: null },
  ];

  return (
    <div className="px-6 py-6">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-2xl">
        {workspaceStatsData.map((stat) => (
          <SimpleStatCard
            key={stat.title}
            title={stat.title}
            value={stat.value}
            icon={stat.icon}
            isLoading={isLoading || isLoadingCounts}
          />
        ))}
      </div>
    </div>
  );
};

export default WorkspaceStatsSection;